/**
 * Overlay.js
 * Controls the dialog overlay
 *
 * @class   Overlay
 * @author  Yevgeniy Rokhlin
 *
 */

import React from 'react';
import ClassNames from 'classnames';

export default React.createClass({



	propTypes: {
		show: React.PropTypes.bool,
		autoLockScrolling: React.PropTypes.bool
	},

	getDefaultProps: function() {
		return {
			autoLockScrolling: true
		};
	},

	componentDidUpdate: function(prevProps, prevState) {
		if (this.props.autoLockScrolling) (this.props.show) ? this._preventScrolling() : this._allowScrolling();
	},

	render: function() {
		let
			{
				className,
			} = this.props,
			classes = ClassNames('lui-overlay', {
				'lui-is-shown': this.props.show
			});

		return (
			<div className={classes} />
		);
	},

	preventScrolling: function() {
		if (!this.props.autoLockScrolling) this._preventScrolling();
	},

	allowScrolling: function() {
		if (!this.props.autoLockScrolling) this._allowScrolling();
	},

	_preventScrolling: function() {
		let body = document.getElementsByTagName('body')[0];
		body.style.overflow = 'hidden';
	},

	_allowScrolling: function() {
		let body = document.getElementsByTagName('body')[0];
		body.style.overflow = '';
	}

});



/** WEBPACK FOOTER **
 ** ./src/components/dialog/overlay.js
 **/